import { useMemo } from 'react';
import MuiAvatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';

const upperCaseFirstLetter = (string) =>
    string.charAt(0).toUpperCase();

const StyledAvatar = styled(MuiAvatar)({
  backgroundColor: '#3374D2',
  color: '#fff',
  width: 40,
  height: 40,
});

const Avatar = ({ firstName, lastName, src }) => {
  const userNameFirstLetters = useMemo(() =>
    `${upperCaseFirstLetter(firstName)}${upperCaseFirstLetter(lastName)}`
  , [firstName, lastName]);

  return (
    <StyledAvatar
      src={src}
      alt={`${firstName} ${lastName}`}
    >
      {userNameFirstLetters}
    </StyledAvatar>
  );
}

export default Avatar;
